// extracted by mini-css-extract-plugin
export default {"card":"i3-z"};